import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  state: {
    logged: false,
    token: {},
    errors: {},
    isWaiting: false,
    isMukellefWaiting: false,
    companyId: null,
    selfMeData: {
      lang: 'tr',
    },
    userIpLocale: null,
    currentPriceFormatNationId: null,
    removePackageData: false,
    isSelectedVirtualOffice: false,
    reCaptchaSiteKey: null,
    turnstileSiteKey: null,
    maxAttempts: 3,
    attemptCount: 0,
    onboardingData: {
      step: 1,
      maxReachedStep: 1,
      companyType: null,
      package: [],
      packageData: [],
      email: null,
      mobile: null,
      userId: null,
      token: null,
      canPassEmailValidation: false,
      companyCountry: null,
    },
    companyData: {},
  },
  mutations: {
    setCompanyId(state, payload) {
      state.companyId = payload;
    },
    setLogin(state, payload) {
      state.logged = true;
      state.token = payload;
    },
    setLogout(state, payload) {
      state.logged = false;
      state.token = {};
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setWaiting(state, status) {
      state.isWaiting = status;
    },
    setMukellefWaiting(state, status) {
      state.isMukellefWaiting = status;
    },
    setAccessToken(state, token) {
      state.token = token;
    },
    setOnlyAccessToken(state, token) {
      state.token.access_token = token;
    },
    setSelf(state, selfMeData) {
      state.selfMeData = selfMeData;
    },
    setCompany(state, data) {
      state.companyData = data;
    },
    setremovePackageData(state, data) {
      state.removePackageData = data;
    },
    setUserIpLocale(state, data) {
      state.userIpLocale = data;
    },
    setisSelectedVirtualOffice(state, data) {
      state.isSelectedVirtualOffice = data;
    },
    setCurrentPriceFormatNationId(state, data) {
      state.currentPriceFormatNationId = data;
    },
    incrementLoginAttempts(state) {
      state.attemptCount++;
    },
    clearLoginAttempts(state) {
      state.attemptCount = 0;
    },
    changeOnboardingData: (state, data) => {
      state.onboardingData[data.variable] = data.value;
    },
    changeSelfMeData: (state, data) => {
      state.selfMeData[data.variable] = data.value;
    },
    clearOnboardingData: (state) => {
      state.onboardingData = {
        step: 1,
        maxReachedStep: 1,
        companyType: null,
        package: [],
        packageData: [],
        email: null,
        mobile: null,
        userId: null,
        token: null,
        canPassEmailValidation: false,
        companyCountry: null,
      };
    },
  },
  actions: {
    getSelf({ commit }) {
      return $axios.get('self/me').then((s) => {
        const form = JSON.parse(JSON.stringify(s.data.data));
        commit('setSelf', form);
      });
    },
    getSelfWithCompanies({ commit }) {
      return $axios.get('self/me?include=companies').then((s) => {
        const form = JSON.parse(JSON.stringify(s.data.data));
        commit('setSelf', form);

        if (form.companies) {
          commit('setCompany', form.companies.data[0]);
        }
      });
    },
    async getCompany() {
      return window.$axios.get('company?include=companyType,users');
    },
  },
  getters: {
    getToken(state, getter) {
      return state.token;
    },
    getAccessToken(state, getter) {
      return state.token.access_token;
    },
    getError: (state) => (key) => {
      const errors = state.errors[key];
      if (errors != null) {
        return errors.join(' ');
      }
    },
    getWaiting(state) {
      return state.isWaiting;
    },
    getMukellefWaiting(state) {
      return state.isMukellefWaiting;
    },
    getSelf(state) {
      return state.selfMeData;
    },
    getReCaptchaSiteKey() {
      return process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY;
    },
    getTurnstileSiteKey() {
      return process.env.VUE_APP_TURNSTILE_SITE_KEY;
    },
    getMaxAttempts(state) {
      return state.maxAttempts;
    },
    getAttemptCount(state) {
      return state.attemptCount;
    },
  },
  plugins: [createPersistedState()],
  strict: debug,
});
